<template>
  <v-flex xs12 pb-3>
    <v-form ref="formSeguradoras" v-model="formValidSeguradoras">
      <v-card >
        <v-toolbar height="56" color="primary" class="overflow-toolbar ">
          <v-toolbar-title class="subheading white--text">
            Seguradoras
          </v-toolbar-title>
        </v-toolbar>
      
        <v-container grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <div class="themeGrey--text">Seguradora*</div>
              <v-autocomplete 
              :error-messages="errorMessages.txtSeguradora"
              ref="txtSeguradoraRef"
              id="txtSeguradora"
              v-model="propostaSeguro.seguradora"
              item-text="nome"
              item-value="id"
              :items="lstSelectSeguradoras"
              placeholder="Selecione uma seguradora"
              no-data-text="Não há seguradoras disponíveis"
              return-object
              validate-on-blur
              @change="validaCampoSeguradora"
              required></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm3>
              <div class="themeGrey--text">Aceite da Solicitação*</div>
              
              <v-switch false-value=false
                :label="`${propostaSeguro.aceita.value ? 'Sim':'Não'}`"
                color="primary"
                v-model.lazy="propostaSeguro.aceita.value"
              ></v-switch>
              
              <v-autocomplete v-if=!propostaSeguro.aceita.value
              label="Motivo*"
              ref="txtMotivoRef"
              id="txtMotivo"
              v-model.lazy="propostaSeguro.aceita.motivo"
              item-text="descricao"
              item-value="descricao"
              :items="lstMotivos"
              :error-messages="errorMessages.txtMotivo"
              @change="validaCampoAceite"
              validate-on-blur
              required></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm3>
              <div class="themeGrey--text">Acidente*</div>
              <v-radio-group 
                v-model="propostaSeguro.acidente.option" 
                :mandatory="false"
                ref="rdAcidenteRef"
                @change="resetCampoAcidente()"
                :error-messages="errorMessages.txtAcidenteRadio"
                >
                <v-radio color="primary" id="chkPropostaSeguroAcidenteTaxa" label="Taxa" value="taxa"></v-radio>
                <v-radio color="primary" id="chkPropostaSeguroAcidenteDesconto" label="Desconto" value="desconto"></v-radio>
              </v-radio-group>
              <template v-if="boolAcidenteTaxa && propostaSeguro.acidente.option">
                <v-text-field
                label="Taxa*"
                v-model.lazy="propostaSeguro.acidente.value"
                validate-on-blur
                ref="txtPropostaSeguroAcidenteTaxaRef"
                id="txtPropostaSeguroAcidenteTaxa"
                :rules="regras.porcentagem"
                @change="validaCampoAcidente"
                :error-messages="errorMessages.txtAcidenteValue"
                required>
                </v-text-field>
              </template>
              <template v-if="boolAcidenteDesconto && propostaSeguro.acidente.option">
                <v-text-field label="Desconto*"
                v-model.lazy="propostaSeguro.acidente.value"
                validate-on-blur
                ref="txtPropostaSeguroAcidenteDescontoRef"
                id="txtPropostaSeguroAcidenteDesconto"
                :rules="regras.porcentagem"
                @change="validaCampoAcidente"
                :error-messages="errorMessages.txtAcidenteValue"
                required>
                </v-text-field>
              </template>
            </v-flex>
            <v-flex xs12 sm3>
              <div class="themeGrey--text">Roubo</div>
              <v-text-field label="Taxa"
                v-model.lazy="propostaSeguro.taxaRoubo"
                validate-on-blur
                ref="txtPropostaSeguroRouboTaxaRef"
                id="txtPropostaSeguroRouboTax"
                :rules="regras.porcentagemTaxaRoubo"
                :error-messages="errorMessages.txtRoubo"
                ></v-text-field>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn id="btnAdicionaPropostaSeguro" 
                @click="adicionaPropostaSeguro" 
                :disabled="!validaProposta"
                color="secondary" 
                :block="$vuetify.breakpoint.xsOnly" 
                class="white--text" >
                  ADICIONAR
              </v-btn>
            </v-flex>
            <v-flex xs12>          
                <v-data-table 
                :headers="cabecalhoPropostasSeguro"
                :items="propostas"
                hide-actions
                :pagination.sync="pagination"
                no-data-text="Nenhuma proposta de seguro foi adicionada"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left themeGrey--text">{{ props.item.seguradora.nome }}</td>
                    <td class="text-xs-left themeGrey--text">
                      {{ props.item.aceita.value ? 'Sim' : 'Não' }} <br/>
                      <template v-if=!props.item.aceita.value>
                        <hr/>
                        Motivo: <br/>
                        {{ props.item.aceita.motivo }}
                      </template>
                    </td>
                    <td class="text-xs-left themeGrey--text">
                      {{ props.item.acidente.option === 'taxa' ? 'Taxa: ' : 'Desconto: ' }}<br/> 
                      {{ toPercentTaxaString(props.item.acidente.value) }}
                    </td>
                    <td class="text-xs-left themeGrey--text">Taxa: <br/>{{ props.item.taxaRoubo ? toPercentTaxaString(props.item.taxaRoubo) : "0,000 %" }}</td>
                    <td class="text-xs-left themeGrey--text">{{ toMoneyString(props.item.premioTotal) }}</td>
                    <td class="text-xs-left themeGrey--text">
                      <v-container fluid>
                        <v-layout v-if="props.item.aceita.value">
                          <v-flex xs12 pt-3>
                            <v-radio-group hide-details
                              v-model="idSeguradoraPropostaSelecionada"
                              name="rowSelector">
                              <v-radio 
                                color="primary"
                                v-model="props.item.seguradora.id"
                                :value="props.item.selecionada"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                        <v-layout v-else>
                          <v-flex xs12 pt-3>
                            <v-radio-group hide-details 
                              v-model="idSeguradoraPropostaSelecionada"
                              name="rowSelector">
                              <v-radio disabled
                                color="primary"
                                :value="props.item.seguradora.id"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </td>
                    <td class="text-xs-left themeGrey--text">
                      <v-container fluid>
                        <v-layout>
                          <v-flex xs12>
                            <v-switch false-value=false
                              v-model="props.item.atendeuExpectativas"
                              hide-details
                              @change="formModificadoFunction()"
                              color="primary">
                              <span slot="label"><small>{{props.item.atendeuExpectativas ? 'Sim' : 'Não'}}</small></span>
                            </v-switch>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </td>
                    <td><v-btn @click.stop="removePropostaSeguro(props.item)" color="primary" flat icon><v-icon>delete</v-icon></v-btn></td>
                  </template>
                </v-data-table>

                <v-flex xs12>
                  <v-btn
                  :disabled="!formModificado"
                  :block="$vuetify.breakpoint.xsOnly" 
                  class="white--text right"
                  @click.native="salvaTodasPropostas"
                  color="primary">
                    Salvar
                    <v-icon right class="hidden-sm-and-down">save</v-icon>
                  </v-btn>
                </v-flex>

            </v-flex>
            <v-snackbar
                :timeout="6000"
                :color="snackbarSalvarPropostas.sucesso ? 'success' : 'error'"
                multi-line
                v-model="snackbarSalvarPropostas.visivel">
                {{ snackbarSalvarPropostas.mensagem }}
                <v-btn dark flat @click.native="snackbarSalvarPropostas.visivel = false">Fechar</v-btn>
              </v-snackbar>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </v-flex>
</template>

<script>
import auditoria from '@/helpers/auditoria';
import CustomFormat from '@/helpers/custom-format'
import cipher from '@/helpers/cipher'
import perfil from '@/helpers/perfil'
import Motivos from '@/helpers/motivos-nao-aceita'
import {VMoney} from 'v-money'
import axios from 'axios'
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  name: 'seguradoras',
  props: ['model'],
  directives: {
    money: VMoney
  },
  data: () => {
    return {
      formValidSeguradoras: false,
      formModSeguradoras: false,
      idSeguradoraPropostaSelecionada: 0,
      lstSeguradoras: [ ],
      lstPropostas: [ ],
      lstMotivos: [ ],
      propostas: [ ],
      propostasExcluidas: [ ],
      propostaSeguro: {
        id: null,
        seguradora: undefined,
        idQuestionario: null,
        premioTotal: 0.0,
        acidente: {
          option: null,
          value: "0"
        },
        taxaRoubo: undefined,
        aceita: {
          value: true,
          motivo: ''
        },
        selecionada: false,
        atendeuExpectativas: false,
        excluida: false,
        dataCriacao: null,
      },
      cabecalhoPropostasSeguro: [
        {text: 'Seguradora', value: 'seguradora'},
        {text: 'Aceite', value: 'aceita'},
        {text: 'Acidente', value: 'acidente'},
        {text: 'Roubo', value: 'taxaRoubo'},
        {text: 'Prêmio Total', value: 'premioTotal'},
        {text: 'Selecionada', value: 'selecionada'},
        {text: 'Atendeu as expectativas?', value: 'atendeuExpectativas'},
        {text: '', value: ''}
      ],
      pagination: {
        sortBy: ''
      },
      errorMessages: {
        txtSeguradora: [],
        txtAceiteSolicitacao: [],
        txtAcidenteValue: [],
        txtAcidenteRadio: [],
        txtRoubo: [],
        txtMotivo: []
      },
      regras: {
        porcentagem: [
          v => ((v == null) || (CustomFormat.removePercentFormat(v) >= 0)) || 'Você precisa informar um valor válido',
          v => ((v == null) || (CustomFormat.removePercentFormat(v) <= 100)) || 'Você precisa informar um valor válido',
          v => ( (v == null) 
                ||  (/^(100)$/g.test(v) && v.length < 8 )
                || (/^(100\,\d{1,3})$/g.test(v) && v.length < 9 )
                || (/^(\d{2})$/g.test(v) && v.length < 6)
                || (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7)
                || (/^(\d{1})$/g.test(v) && v.length < 5)
                || (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) )
                || 'Você precisa informar um valor válido'
        ],
        porcentagemTaxaRoubo: [
          v => ((v == null) || (CustomFormat.removePercentFormat(v) >= 0)) || 'Você precisa informar um valor válido',
          v => ((v == null) || (CustomFormat.removePercentFormat(v) <= 100)) || 'Você precisa informar um valor válido',
          v => ( (v == null) 
                ||  (/^(100)$/g.test(v) && v.length < 8 )
                || (/^(100\,\d{1,3})$/g.test(v) && v.length < 9 )
                || (/^(\d{2})$/g.test(v) && v.length < 6)
                || (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7)
                || (/^(\d{1})$/g.test(v) && v.length < 5)
                || (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) )
                || 'Você precisa informar um valor válido'
            ]
      },
      maskPercent: {
        decimal: ',',
        thousands: '.',
        suffix: ' %',
        precision: 2,
        masked: false
      },
      maskPercentTaxa: {
        decimal: ',',
        thousands: '.',
        suffix: ' %',
        precision: 3,
        masked: false
      },
      snackbarSalvarPropostas: {
            sucesso: true,
            visivel: false,
            mensagem: ''
        },
    }
  },
  computed: {
    boolAcidenteTaxa: function () {
      return this.propostaSeguro.acidente.option == 'taxa';
    },
    boolAcidenteDesconto: function () {
      return this.propostaSeguro.acidente.option == 'desconto';
    },
    isCliente: function() {
      return perfil.isCliente(usuarioHelper.USUARIO_LOGADO().perfil.id);
    },
    lstSelectSeguradoras: function () {
        let idsSelecionados = this.propostas.map((x) => { return x.seguradora.id });
        return this.lstSeguradoras.filter((x) => { return idsSelecionados.indexOf(x.id) == -1 });
    },
    formModificado: function () {
        return this.formModSeguradoras;
    },
    validaProposta: function () {
      return this.formValidSeguradoras 
            && this.propostaSeguro.acidente.value 
            && this.propostaSeguro.acidente.option 
            && this.propostaSeguro.seguradora;
    },
  },
  watch: {
    idSeguradoraPropostaAtendeuExpectativas: function (newValue, oldValue) {
      const self = this;
      var proposta = (self.propostas.filter((x) => { return x.seguradora.id == newValue }))[0];
      proposta.atendeuExpectativas = !proposta.atendeuExpectativas;
      self.formModSeguradoras = true;
    },
    idSeguradoraPropostaSelecionada: function (newValue, oldValue) {
      const self = this;
      var propostaSelecionada = (self.propostas.filter((x) => { return x.seguradora.id == newValue }))[0];
      var propostaSelecionadaAnterior = (self.propostas.filter((x) => { return x.seguradora.id == oldValue }))[0];
      if (propostaSelecionada) {
        propostaSelecionada.selecionada = true;
        self.formModSeguradoras = true;
      }
      if (propostaSelecionadaAnterior) {
        propostaSelecionadaAnterior.selecionada = false;
      }
    }
  },
  mounted: function () {
    this.carregaSeguradoras();
    this.carregaMotivos();
    this.carregaPropostas();
    this.formModSeguradoras = false;
  },
  methods: {
    formModificadoFunction: function  () {
      const self = this;
      self.formModSeguradoras = true;
    },
    carregaMotivos: function () {
      return this.lstMotivos = Motivos;
    },
    carregaSeguradoras: function () {
        const self = this;
        axios.get(`${process.env.URL_SEGURADORAMS}/v1/no-auth/buscaTodasSeguradoras`)
          .then((response) => {
            const data = response.data;
            if (data) {
                self.lstSeguradoras = data.sort((a, b) => { return a.nome.localeCompare(b.nome) });
            }
          }).catch((err) => {
            console.log(err);
          });
    },
    carregaPropostas: function () {
      const self = this;
      axios.get(`${process.env.URL_SEGURADORAMS}/v1/buscaTodasPropostasSeguro?id=${cipher.decrypt(self.$route.params.id)}`,
          { headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          } })
        .then((response) => {
          const data = response.data;
          if (data) {
            self.lstPropostas = data;
            self.propostas = [];
            self.lstPropostas.forEach( function (p) {
              let proposta = self.montaModeloView(p);
              if(proposta.selecionada) {
                self.idSeguradoraPropostaSelecionada = proposta.seguradora.id;
              }
              self.propostas.push(proposta);
            });
            self.propostas.sort((a, b) => { return a.seguradora.nome.localeCompare(b.seguradora.nome) });
          }
        }).catch((err) => {
          console.log(err);
        });
    },
    resetCampoAcidente: function () {
      this.propostaSeguro.acidente.value = undefined;
      if(this.$refs.txtPropostaSeguroAcidenteTaxaRef)
        this.$refs.txtPropostaSeguroAcidenteTaxaRef.reset();
      if(this.$refs.txtPropostaSeguroAcidenteDescontoRef)
        this.$refs.txtPropostaSeguroAcidenteDescontoRef.reset();
      this.errorMessages.txtAcidenteValue = "";
    },
    montaModeloEnvioTarifador: function (proposta) {
      const self = this;
      let modelo = {};
      modelo.id = proposta.id ? proposta.id : null;
      modelo.idSeguradora = proposta.seguradora.id;
      modelo.idQuestionario = self.model.id;
      modelo.taxaAcidente = (proposta.acidente.option === 'taxa') ? self.toPercentFloat(proposta.acidente.value) : null;
      modelo.descontoAcidente = (proposta.acidente.option === 'desconto') ? self.toPercentFloat(proposta.acidente.value) : null;
      modelo.taxaRoubo = proposta.taxaRoubo ? self.toPercentFloat(proposta.taxaRoubo) : null;
      modelo.premioTotal = proposta.premioTotal;
      modelo.aceita = proposta.aceita.value;
      modelo.motivo = modelo.aceita ? null : proposta.aceita.motivo;
      modelo.selecionada = proposta.selecionada;
      modelo.atendeuExpectativas = proposta.atendeuExpectativas;
      modelo.excluida = proposta.excluida;
      modelo.dataCriacao = proposta.dataCriacao;
      return modelo;
    },
    montaModeloEnvio: function (proposta) {
      const self = this;
      let modelo = {};
      modelo.id = proposta.id ? proposta.id : null;
      modelo.idSeguradora = proposta.seguradora.id;
      modelo.idQuestionario = self.model.id;
      modelo.taxaAcidente = (proposta.acidente.option === 'taxa') ? proposta.acidente.value : null;
      modelo.descontoAcidente = (proposta.acidente.option === 'desconto') ? proposta.acidente.value : null;
      modelo.taxaRoubo = proposta.taxaRoubo ? proposta.taxaRoubo : null;
      modelo.premioTotal = proposta.premioTotal;
      modelo.aceita = proposta.aceita.value;
      modelo.motivo = modelo.aceita ? null : proposta.aceita.motivo;
      modelo.selecionada = proposta.selecionada;
      modelo.atendeuExpectativas = proposta.atendeuExpectativas;
      modelo.excluida = proposta.excluida;
      modelo.dataCriacao = proposta.dataCriacao;
      return modelo;
    },
    montaModeloView: function (propostaRecebida) {
      const self = this;
      let propostaView = {};  
      propostaView.id = propostaRecebida.id;
      propostaView.seguradora = (self.lstSeguradoras.filter((x) => { return x.id == propostaRecebida.idSeguradora }))[0];
      propostaView.idQuestionario = propostaRecebida.idQuestionario;
      propostaView.premioTotal = propostaRecebida.premioTotal;
      propostaView.acidente = {};
      propostaView.acidente.option = propostaRecebida.taxaAcidente ? 'taxa' : 'desconto';
      propostaView.acidente.value = propostaRecebida.taxaAcidente ? propostaRecebida.taxaAcidente : propostaRecebida.descontoAcidente;
      propostaView.taxaRoubo = propostaRecebida.taxaRoubo ? propostaRecebida.taxaRoubo : 0.0; 
      propostaView.aceita = {};
      propostaView.aceita.value = propostaRecebida.aceita;
      propostaView.aceita.motivo = propostaRecebida.aceita ? '' : propostaRecebida.motivo;
      propostaView.selecionada = propostaRecebida.selecionada;
      propostaView.atendeuExpectativas = propostaRecebida.atendeuExpectativas;
      propostaView.excluida = propostaRecebida.excluida;
      propostaView.dataCriacao = propostaRecebida.dataCriacao;
      return propostaView;
    },
    adicionaPropostaSeguro: function () {
      const self = this;
      self.propostaSeguro.idQuestionario = self.model.id;
      if (self.validaAddPropostaSeguro()) {
        self.$store.commit('startLoading');
        if(!self.propostaSeguro.aceita.value) {
          self.propostaSeguro.premioTotal = self.model.novoSeguro.premioTotal;
          self.propostaSeguro.taxaRoubo = this.toPercentFloat(self.propostaSeguro.taxaRoubo);
          self.propostaSeguro.acidente.value = this.toPercentFloat(self.propostaSeguro.acidente.value);
          self.propostas.push(Object.assign({}, self.propostaSeguro));
          self.propostas.sort((a, b) => { return a.seguradora.nome.localeCompare(b.seguradora.nome) });
          self.limpaCamposPropostaSeguro();
          self.formModSeguradoras = true;
          self.$store.commit('endLoading');
        } else {
          var propostaModel = self.montaModeloEnvioTarifador(self.propostaSeguro);
          axios.post(
            `${process.env.URL_TARIFADORMS}/v1/calculaPremioProposta`,
            propostaModel,
            { headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`}   })
            .then((response) => {
              const data = response.data;
              if (data) {
                self.propostaSeguro.premioTotal = data;
                self.propostaSeguro.taxaRoubo = this.toPercentFloat(self.propostaSeguro.taxaRoubo);
                self.propostaSeguro.acidente.value = this.toPercentFloat(self.propostaSeguro.acidente.value);
                self.propostas.push(Object.assign({}, self.propostaSeguro));
                self.propostas.sort((a, b) => { return a.seguradora.nome.localeCompare(b.seguradora.nome) });
                self.limpaCamposPropostaSeguro();
                self.formModSeguradoras = true;
              }
              self.$store.commit('endLoading');
            }).catch((err) => {
              console.log(err);
              self.$store.commit('endLoading');
          });
        }
      }
    },
    limpaCamposPropostaSeguro: function () {
      const self = this;
      self.propostaSeguro.id = null;
      self.propostaSeguro.seguradora = {};
      self.propostaSeguro.idQuestionario = self.model.id;
      self.propostaSeguro.premioTotal = 0.0;
      self.propostaSeguro.acidente = {option: undefined, value: undefined};
      self.propostaSeguro.taxaRoubo = null;
      self.propostaSeguro.aceita = { value: true, motivo: ''};
      self.propostaSeguro.selecionada = false;
      self.propostaSeguro.atendeuExpectativas = false;
      self.propostaSeguro.excluida = false;
      self.propostaSeguro.dataCriacao = null;

      self.$refs.txtSeguradoraRef.reset();

    },
    validaAddPropostaSeguro: function () {  
      var erro = false;
      erro = this.validaCampoSeguradora() || erro;
      erro = this.validaCampoAceite() || erro;
      erro = this.validaCampoAcidente() || erro;
      return !erro;
    },
    validaCampoSeguradora: function () {
      const self = this;
      let erro = false;

      self.errorMessages.txtSeguradora = [];
      if (!self.propostaSeguro.seguradora || Object.keys(self.propostaSeguro.seguradora).length == 0) {
        erro = erro || true;
        self.errorMessages.txtSeguradora = ['Você não pode deixar este campo em branco'];
      }

      return erro;
    },
    validaCampoAceite: function () {
      const self = this;
      let erro = false;

      self.errorMessages.txtMotivo = [];
      if(self.propostaSeguro.aceita.value == false) {
        if (!self.propostaSeguro.aceita.motivo) {
          erro = erro || true;
          self.errorMessages.txtMotivo = ['Você não pode deixar este campo em branco'];
        }
      }

      return erro;
    },
    validaCampoAcidente: function () {
      const self = this;
      let erro = false;

      self.errorMessages.txtAcidenteRadio = [];
      if (!self.propostaSeguro.acidente.option) {
        erro = erro || true;
        self.errorMessages.txtAcidenteRadio = ['Você precisa selecionar um opção'];
      }

      self.errorMessages.txtAcidenteValue = [];
      if (self.propostaSeguro.acidente.option 
          && (CustomFormat.removePercentFormat(self.propostaSeguro.acidente.value) <= 0
          || CustomFormat.removePercentFormat(self.propostaSeguro.acidente.value) > 100)) {
        erro = erro || true;
        self.errorMessages.txtAcidenteValue = ['Você precisa informar um valor válido'];
      }

      return erro;
    },
    removePropostaSeguro: function (item) {
      const self = this;
      let index = self.propostas.indexOf(item);
      if(item.id) {
        item.excluida = true;
        self.propostasExcluidas.push((self.propostas.splice(index, 1)).shift());
        self.formModSeguradoras = true;
      } else {
        self.propostas.splice(index, 1);
      }
    },
    salvaTodasPropostas: function () {
      const self = this;
      self.$store.commit('startLoading');
      let propostasSalvar = [];
      self.propostas.forEach(function (p) {
        propostasSalvar.push(self.montaModeloEnvio(p));
      });
      self.propostasExcluidas.forEach(function (p) {
        propostasSalvar.push(self.montaModeloEnvio(p));
      });
      axios.post(`${process.env.URL_SEGURADORAMS}/v1/salvaTodasPropostasSeguro`, propostasSalvar, {
        headers: {
          'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      }).then((response) => {
          self.carregaPropostas();
          self.$store.commit('endLoading');
          self.snackbarSalvarPropostas.visivel = true;
          if (response.data) {
            self.propostasExcluidas.forEach(function (p) {
              auditoria.registrar(`Excluiu a cotação da seguradora ${p.seguradora.nome}`, self.model.protocolo, self.$parent.transportadoraModel.nome);
            });   
            self.propostasExcluidas = [];
            self.snackbarSalvarPropostas.sucesso = true;
            self.snackbarSalvarPropostas.mensagem = 'Os dados foram salvos com sucesso'            
          } else {
            self.snackbarSalvarPropostas.sucesso = false;
            self.snackbarSalvarPropostas.mensagem = 'Ocorreu um erro ao salvar os dados'
          }
          self.formModSeguradoras = false;
          
        }).catch((err) => {
          console.log(err);
          self.$store.commit('endLoading');
        });
    },
    toMoneyString: function (val) {
      return CustomFormat.toMoneyString(val);
    },
    toPercentString: function (val) {
      return CustomFormat.toPercentString(val);
    },
    toPercentTaxaString: function (val) {
      return CustomFormat.toPercentTaxaString(val);
    },
    toLocaleDateString: function (val) {
      return CustomFormat.toLocaleDateString(val);
    },
    toPercentFloat: function (val) {
      return CustomFormat.virgulaParaPonto(val);
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/solicitacao-consulta/Seguradoras.vue